<template>
  <v-row wrap>
    <v-col sm="12">
      <v-card flat>
        <v-card-title>
          <v-text-field
            append-icon="search"
            :label="t('search')"
            single-line
            hide-details
            v-model="search"
            variant="underlined"
          />
        </v-card-title>
      </v-card>
      <v-card flat border>
        <v-card-text class="d-block px-0 py-0">
          <v-data-table-server
            v-if="workOrderCategoriesList"
            :headers="headers"
            :items="workOrderCategoriesList"
            :items-length="workOrderCategoriesListTotalCount"
            :loading="workOrderCategoriesListLoading"
            :search="search"
            :items-per-page-text="rowsPerPageText"
            :items-per-page-options="rowsPerPageItems"
            v-model:items-per-page="pagination.rowsPerPage"
            v-model:page="pagination.page"
            @update:options="getWorkOrderCategories"
            @update:sort-by="sortEvent"
          >
            <template v-slot:headers="{isSorted, getSortIcon, toggleSort }">
              <tr>
                <template v-for="header in headers" :key="header.key" >
                  <th class="custom_header_table custom-bg" :style="{width: `${header.width}px !important`}" >
                    <span class="d-flex align-center" @click="header.sortable ? toggleSort(header) : ''">
                      <span class="cursor-pointer">{{ header.title }}</span>
                      <template v-if="isSorted(header)">
                        <v-icon :icon="getSortIcon(header)" size="small"></v-icon>
                      </template>
                    </span>
                  </th>
                </template>
              </tr>
            </template>

            <template v-slot:item="{ item } : {item : any}">
              <tr>
                <td>
                  <router-link v-if="auth.check('edit work order categories')" :to="{ name: 'WorkOrderCategoriesEdit', params: { id: item.id }}">
                    <CategoryBadge :category="item" />
                  </router-link>
                  <CategoryBadge v-else :category="item" />
                </td>
                <td class="text-right">
                  <v-btn v-if="auth.check('edit work order categories')" variant="text" :to="{ name: 'WorkOrderCategoriesEdit', params: { id: item.id }}" icon flat>
                    <v-icon color="grey">mdi-pencil</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table-server>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { datatableOptions } from '@/mixins/datatableOptions'
import { ref, computed, onBeforeMount } from 'vue'
import store from '@/store'
import { workOrderCategoryStore } from '@/store/workOrderCategories'
import { useI18n } from 'vue-i18n'
import { useAuth } from '@/utils/auth'
import CategoryBadge from '@/components/WorkOrders/CategoryBadge.vue'

const auth = useAuth()
const { t } = useI18n()

const search = ref('')
const headers: any = ref([
  { title: t('name'), key: 'name', sortable: true },
  { key: '', sortable: false, width: 100 }
])
const workOrderCategoriesList = computed(() => workOrderCategoryStore.getters.workOrderCategories)
const workOrderCategoriesListLoading = computed(() => workOrderCategoryStore.getters.workOrderCategoryListLoading)
const workOrderCategoriesListTotalCount = computed(() => workOrderCategoryStore.getters.workOrderCategoryListTotal)

const { rowsPerPageItems, rowsPerPageText, pagination } = datatableOptions()

onBeforeMount(() => {
  store.commit('app.setPageTitle', t('workOrderCategory', 2))
  store.commit('app.setBreadcrumbs', [
    { text: t('workOrderCategory', 2) }
  ])
})

const getWorkOrderCategories = () => {
  workOrderCategoryStore.dispatch('fetchWorkOrderCategories', Object.assign(
    pagination.value,
    {
      search: search.value,
    }
  ))
}

const sortEvent = (value: any) => {
  if(value.length === 0) {
    return
  }
  pagination.value.sortBy = value[0].key
  pagination.value.descending = value[0].order === 'desc' ? true : false
}
</script>
